// ======================================================================
// File Name       : distribution
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import * as actionTypes from '../../../constants/actionTypes/report';

export function receiveDistributionReportSearch(reportListResult) {
  return {
    type: actionTypes.DISTRIBUTION_REPORT_SEARCH,
    reportListResult: reportListResult || {},
  };
}

export function receiveDistributionReportGet(result) {
  return {
    type: actionTypes.DISTRIBUTION_REPORT_GET,
    distributionReportListResult: result.reportList || [],
  };
}

export function receiveDistributionReportCount(result) {
  return {
    type: actionTypes.DISTRIBUTION_REPORT_COUNT,
    reportListResult: result || {},
  };
}

export function receiveDistributionReportCheckingCount(result) {
  return {
    type: actionTypes.DISTRIBUTION_REPORT_CHECKING_COUNT,
    checkerUserList: result.checkerUserList ? result.checkerUserList : [],
  };
}

export function receiveReportData(itemReportIdAuto) {
  return {
    type: actionTypes.OPEN_ASSIGNMENT_DISTRIBUTION_REPORT_DIALOG,
    itemReportIdAuto,
  };
}

export function receiveUserListSearch(userResult) {
  return {
    type: actionTypes.DISTRIBUTION_REPORT_USER_LIST_SEARCH,
    userResult,
  };
}

export function receiveManagementAuthorityList(managementAuthorityList) {
  return {
    type: actionTypes.DISTRIBUTION_REPORT_SET_MANAGEMENT_AUTHORITY_LIST,
    managementAuthorityList,
  };
}

export function receiveDistributionReportUpdate(updateResult) {
  return {
    type: actionTypes.DISTRIBUTION_REPORT_UPDATE,
    updateResult,
  };
}

export function receiveResetReportUpdateResult() {
  return {
    type: actionTypes.DISTRIBUTION_REPORT_RESET_UPDATE_RESULT,
  };
}

export function receiveGroupList(result) {
  return {
    type: actionTypes.DISTRIBUTION_REPORT_GROUP_LIST,
    groupList: result.groupList,
  };
}

export function receiveAuthorityList(responseData) {
  return {
    type: actionTypes.DISTRIBUTION_REPORT_AUTHORITY_LIST,
    managementAuthorityList: responseData.managementAuthorityList,
  };
}

export function receiveReportAssignmentResetInit() {
  return {
    type: actionTypes.DISTRIBUTION_REPORT_ASSIGNMENT_RESET_INIT,
  };
}

export function receiveReportResetInit() {
  return {
    type: actionTypes.DISTRIBUTION_REPORT_RESET_INIT,
  };
}

export function receiveDistribtutionReportUpdateSearchInfo(searchInfo) {
  return {
    type: actionTypes.DISTRIBUTION_REPORT_UPDATE_SEARCH_INFO,
    searchInfo,
  };
}

export function receiveDistribtutionReporDetailUpdateSearchInfo(searchInfo) {
  return {
    type: actionTypes.DISTRIBUTION_REPORT_DETAIL_UPDATE_SEARCH_INFO,
    searchInfo,
  };
}

export function receiveUpdateUserListInfo(userListInfo) {
  return {
    type: actionTypes.DISTRIBUTION_REPORT_DETAIL_UPDATE_USER_LIST_INFO,
    userListInfo,
  };
}
